module.exports = __webpack_public_path__ + "static/img/qualifications_row_7.288a9b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_7.png
// module id = GYo5
// module chunks = 1